/**
 * The rise and shrink of a floating label, enabled only once the user has engaged the field.
 *
 * A field whose value is already there when it appears — a form populated from a saved draft, a
 * value that arrives a moment after the first render — must show its label already floated. If the
 * transition is on from the start, every pre-filled label plays the rise as the form loads, which
 * is a row of labels moving for no reason the user caused.
 *
 * `data-focused` covers the user moving into the field and `data-touched` covers the user leaving
 * it, so focus, typing, and blurring an emptied field all still animate. A change made to the value
 * from outside, before anyone has touched the field, snaps to its state.
 *
 * `motion-safe:` rather than a `motion-reduce:transition-none` override, so there is one rule and
 * no ordering to get wrong.
 */
export const FLOATING_LABEL_MOTION = [
  'motion-safe:group-data-[focused]/ti:transition-[translate,scale,color]',
  'motion-safe:group-data-[focused]/ti:duration-[var(--motion-control)]',
  'motion-safe:group-data-[focused]/ti:ease-[var(--motion-control-ease)]',
  'motion-safe:group-data-[touched]/ti:transition-[translate,scale,color]',
  'motion-safe:group-data-[touched]/ti:duration-[var(--motion-control)]',
  'motion-safe:group-data-[touched]/ti:ease-[var(--motion-control-ease)]',
].join(' ');

/** The glyph that arrives with a floating label, which has to stay in step with it. */
export const FLOATING_GLYPH_MOTION = [
  'motion-safe:group-data-[focused]/ti:transition-[opacity,scale]',
  'motion-safe:group-data-[focused]/ti:duration-[var(--motion-control)]',
  'motion-safe:group-data-[focused]/ti:ease-[var(--motion-control-ease)]',
  'motion-safe:group-data-[touched]/ti:transition-[opacity,scale]',
  'motion-safe:group-data-[touched]/ti:duration-[var(--motion-control)]',
  'motion-safe:group-data-[touched]/ti:ease-[var(--motion-control-ease)]',
].join(' ');
